/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaskedInput/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function MaskedInput({
  children,
  viewPath = "/DesignSystem/MaskedInput",
  autoComplete = "on",
  autoFocus,
  className,
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  borderColor = "transparent",
  borderWidth = 0,
  fontSize = 16,
  fontWeight = 300,
  marginTop = 0,
  marginBottom = 0,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  onSubmit,
  paddingBottom = 4,
  paddingRight = 8,
  paddingLeft = 0,
  paddingTop = 4,
  placeholder,
  innerRef,
  textTransform = "capitalize"
  
}) {
  return (<React.Fragment
>
<input
 type="text"
  data-testid="MaskedInput.MaskedInput"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 onSubmit={onSubmit}
 placeholder={placeholder}
 ref={innerRef}
 style={{'--bblr-1-Zo1G5V': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-Zo1G5V': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-Zo1G5V': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-Zo1G5V': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bc-5-Zo1G5V': borderColor,'--bw-6-Zo1G5V': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--fs-7-Zo1G5V': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-8-Zo1G5V': fontWeight,'--mt-9-Zo1G5V': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-10-Zo1G5V': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pb-11-Zo1G5V': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-12-Zo1G5V': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pl-13-Zo1G5V': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pt-14-Zo1G5V': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--tt-15-Zo1G5V': textTransform}}
 className={`views-capture ${className} ${styles.MaskedInput1}`}
/>
{children}
</React.Fragment>)
}